import { FC, MouseEvent as ReactMouseEvent } from 'react';
import { NavLinkProps } from 'react-router-dom';

import useCompanyContext from 'common/hooks/useCompanyContext';
import SunshineIcon from 'components/_core/SunshineIcon';
import { logEvent } from 'features/Analytics/analytics';

import { getRebrandedIconName } from './helpers';
import * as S from './styles';
import { NavMenuItemProps } from './types';

const NavMenuItem: FC<NavMenuItemProps> = ({
  children,
  icon,
  label,
  onClick,
  to,
  ...props
}) => {
  const { companyProfileId, companyUserId } = useCompanyContext();

  return (
    <S.NavLink
      {...(props as NavLinkProps)}
      _hover={{
        _after: {},
        color: 'grey.800',
      }}
      color="grey.700"
      onClick={(e: ReactMouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        logEvent({
          name: 'Click_Menu_Link',
          properties: {
            companyProfileId,
            companyUserId,
            label,
            to,
          },
        });
        onClick?.(e);
      }}
      position="relative"
      sx={{
        '&[aria-current]': {
          color: 'grey.800',
        },
        '&[aria-current] .label': {
          _before: {
            backgroundColor: 'grey.800',
            bottom: 0,
            content: '""',
            height: 1.5,
            left: 0,
            position: 'absolute',
            right: 0,
          },
        },
      }}
      to={to}
      width="fit-content"
    >
      <SunshineIcon name={getRebrandedIconName(icon)} />

      <S.Label className="label" color="inherit" position="relative">
        {label}
      </S.Label>

      {children}
    </S.NavLink>
  );
};

export default NavMenuItem;
